<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-06-20 10:27:47
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-11-04 17:48:25
 * @FilePath: /wemeet-admin-new/src/views/exhibitionManage/components/exportRegister.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer"
    :direction="direction"
    :size="size"
    :title="title"
  >
    <div class="containerForm">
      <div><el-tag type="danger">以下显示已经创建了身份的表单数据。</el-tag></div>
      <el-button style="margin-bottom: 10px; margin-top: 10px" @click="handleData">刷新</el-button>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="自定义身份名称" prop="name" width="159" />
        <el-table-column label="身份类型" prop="identityName" width="159" />
        <el-table-column label="时间" width="285">
          <template #default="{ row }">
            <template v-if="row.exportParams && row.exportParams.status == 'SUCCESS'">
              <el-tag type="success">生成成功 {{ handleDate(row.exportParams.createTime) }}</el-tag>
            </template>
            <template v-if="row.exportParams && row.exportParams.status == 'PENDING'">
              <el-tag type="info">正在生成中... {{ handleDate(row.exportParams.createTime) }}</el-tag>
            </template>
            <template v-if="row.exportParams && row.exportParams.status == 'FAIL'">
              <el-tag type="danger">
                生成失败: {{ row.exportParams.remark }}{{ handleDate(row.exportParams.createTime) }}
              </el-tag>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" show-overflow-tooltip width="285">
          <template #default="{ row }">
            <el-button v-if="!row.isExport" type="primary" @click="handleOpenDialog(row)">生成报表</el-button>
            <template v-else>
              <template v-if="row.exportParams.status == 'SUCCESS'">
                <el-button type="primary" @click="handleOpenDialog(row)">重新生成</el-button>
                <el-button type="success" @click="exportFile(row)">下载报表</el-button>
              </template>
              <template v-if="row.exportParams.status == 'PENDING'">
                <el-button type="info">重新生成</el-button>
              </template>
              <template v-if="row.exportParams.status == 'FAIL'">
                <el-button type="primary" @click="handleOpenDialog(row)">重新生成</el-button>
              </template>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="demo-drawer__footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSave">提交</el-button>
    </div>
  </el-drawer>
  <el-dialog v-model="visible" title="提示">
    <p>
      因我方运营需求，需要生成并导出用户信息。导出的用户信息仅用于运营用途，我方承诺不会泄露用户隐私。如有泄露或造成纠纷，我方会承担相应法律责任。
    </p>
    <el-checkbox v-model="isCheck" label="请勾选确认" size="large" />
    <template #footer>
      <el-button v-if="pararms.type != `MEETING_SIGN_REPORT`" type="primary" @click="handleExport(checkRow, 'N')">
        导出脱敏信息
      </el-button>
      <el-button type="primary" @click="handleExport(checkRow, 'Y')">导出完整信息</el-button>
    </template>
  </el-dialog>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { getRegisterConfigList, dataGetB, dataExportB } from '@/api/exhibitionManage'
  import { parseTime } from '@/utils/index'
  export default defineComponent({
    name: 'EditConfigDrawer',

    setup(props, { emit }) {
      /**
       * @description: cover主k 自定义校验
       * @return {*}
       */

      const { proxy } = getCurrentInstance()
      const state = reactive({
        form: {
          categoryName: '',
          meetingCode: '',
          originalPrice: '',
          remark: '',
          sellingPrice: '',
          sort: '',
          coverUrl: '',
        },
        dialogFormVisible: false,
        direction: 'rtl',
        size: '50%',
        pararms: {
          type: 'MEETING_REGISTER_REPORT',
        },
        title: '注册报表导出',
        tableData: [],
        isCheck: false,
        visible: false,
        checkRow: {},
        // exportLoading: false,
      })

      // 打开
      const handleOpen = async (row = {}, title, type) => {
        state.title = title
        state.pararms = {
          relationCode: row.code,
          relationType: row.relationType,
          type: type,
        }
        state.form = Object.assign(state.form, row)
        handleData()
        state.dialogFormVisible = true
      }
      const handleData = async () => {
        try {
          let { data } = await getRegisterConfigList(state.form.code)

          const { data: list } = await dataGetB(state.pararms)

          if (state.pararms.type == `MEETING_SIGN_REPORT`) {
            data = [
              {
                name: '签到数据',
                identity: 'AUDIENCE',
                isExport: list.length > 0 ? true : false,
                exportParams: list.length > 0 ? list[list.length - 1] : {},
              },
            ]
          } else if (state.pararms.type == 'EXHIBITION_FORUM_REGISTER_REPORT') {
            data = [
              {
                name: '会议数据',
                identity: 'AUDIENCE',
                isExport: list.length > 0 ? true : false,
                exportParams: list.length > 0 ? list[list.length - 1] : {},
              },
            ]
          } else if (state.pararms.type == 'TICKET_REGISTER_REPORT') {
            data = [
              {
                name: '门票表单下载',
                identity: 'AUDIENCE',
                isExport: list.length > 0 ? true : false,
                exportParams: list.length > 0 ? list[list.length - 1] : {},
              },
            ]
          } else {
            data.forEach((v) => {
              v.isExport = false
            })

            if (list.length > 0) {
              list.forEach((v) => {
                data.forEach((sv) => {
                  if (v.subType == sv.identity) {
                    sv.isExport = true
                    sv.exportParams = v
                  }
                })
              })
            }
          }

          console.log(data, '====>>>')

          state.tableData = data
        } catch (err) {
          console.log(err, '----')
        }
      }
      // 关闭
      const handleClose = () => {
        state.dialogFormVisible = false
      }
      const handleOpenDialog = async (row) => {
        state.checkRow = row
        // if (state.pararms.type == `MEETING_SIGN_REPORT`) {
        //   let params = {
        //     subType: row.identity,
        //     type: state.pararms.type,
        //     relationCode: state.form.code,
        //     relationType: state.form.relationType,
        //   }
        //   state.checkRow = {}
        //   state.visible = false
        //   state.isCheck = false
        //   try {
        //     const { data } = await dataExportB(params)
        //     console.log(data)
        //     handleData()
        //   } catch (err) {
        //     proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
        //   }
        // } else {
        // }
        state.visible = true
        // handleExport(row)
      }
      const handleExport = async (row, isReal) => {
        if (!state.isCheck) {
          proxy.$baseMessage(`请先勾选确认`, 'error', 'vab-hey-message-error')
          return false
        }
        let params = {
          subType: row.identity,
          type: state.pararms.type,
          relationCode: state.form.code,
          relationType: state.form.relationType,
          isReal,
        }
        state.checkRow = {}
        state.visible = false
        state.isCheck = false
        try {
          const { data } = await dataExportB(params)
          console.log(data)
          handleData()
        } catch (err) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
        }
      }

      const exportFile = (row) => {
        window.open(row.exportParams.fileUrl)
      }
      const handleDate = (val) => {
        return parseTime(val)
      }

      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        handleExport,
        exportFile,
        handleDate,
        handleData,
        handleOpenDialog,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    width: 100%;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }
</style>
